import { uploadRepository } from '@/infrastructure/repositories';
import { UploadResponse, HttpError } from '@/domain/entities';

export class UploadService {
  async uploadImage(file: File, folder?: string): Promise<UploadResponse> {
    try {
      return await uploadRepository.uploadImage(file, folder);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось загрузить изображение');
    }
  }
}

export const uploadService = new UploadService();
